import type { ChangeEvent } from 'react'

import { formatCurrency } from '@/core/utils/currency'

import { LOAN_FORM_CONFIG, type PossibleMonthlyInstallments } from '../constants'

import { useLoanSimulatorProvider } from '../LoanSimulatorProvider'

import LoanStepInput from './LoanStepInput'
import { useLoanForm } from './useLoanForm'

interface Props {
  className?: string
}

const LoanForm = ({ className }: Props) => {
  const { installments, moneyAmount, setInstallments, setMoneyAmount } = useLoanSimulatorProvider()
  const {
    moneyAmountInputConfig,
    installmentsInputConfig,
    formatInputValue,
    setInstallmentsRange,
    setMoneyAmountRange,
  } = useLoanForm()

  const onChangeMoneyAmount = (event: ChangeEvent<HTMLInputElement>) => {
    const parsedRange = parseInt(event.target.value, 10)
    setMoneyAmountRange(parsedRange)

    const parsedValue = formatInputValue(parsedRange, LOAN_FORM_CONFIG.moneyAmount)
    setMoneyAmount(parsedValue)
  }

  const onChangeInstallments = (event: ChangeEvent<HTMLInputElement>) => {
    const parsedRange = parseInt(event.target.value, 10)
    setInstallmentsRange(parsedRange)

    const parsedValue = formatInputValue<PossibleMonthlyInstallments>(
      parsedRange,
      LOAN_FORM_CONFIG.installments,
    )
    setInstallments(parsedValue)
  }

  return (
    <form className={className}>
      <LoanStepInput
        label="De quanto você precisa?"
        onChange={onChangeMoneyAmount}
        className="eu-sm-2"
        inputName="money-amount"
        labeledByName="money-amount-aria"
        valueLabel={formatCurrency(moneyAmount)}
        {...moneyAmountInputConfig}
      />

      <LoanStepInput
        label="Em quantos meses quer pagar?"
        onChange={onChangeInstallments}
        valueLabel={`${installments} meses`}
        className="eu-sm-2"
        labeledByName="installments-aria"
        aria-valuetext={`${installments} meses`}
        inputName="installments"
        {...installmentsInputConfig}
      />
    </form>
  )
}

export default LoanForm
